export const home = {
  canonical: "https://www.nextcosmostechnology.com/",
  title: "Next Cosmos Technology : Building Custom Software Solutions",
  description:
    "End-to-end IT software solutions delivering scalable custom software development and comprehensive IT consulting services tailored to your business needs.",
  ogTitle: "Home : Building Custom Software Solutions",
};

export const about = {
  canonical: "https://www.nextcosmostechnology.com/about",
  title: "End-to-End Software Solutions & IT Services for Every Business",
  description:
    "Complete software solutions and IT services tailored for every business. From custom development to consulting, we deliver results that drive growth.",
  ogTitle: "Who we are : End-to-End Software Solutions & IT Services",
};

export const service = {
  canonical: "https://www.nextcosmostechnology.com/services",
  title: "Scalable Custom Software Development & IT Consulting Services",
  description:
    "Comprehensive scalable software development and IT consulting services designed to optimize your business operations and drive growth.",
  ogTitle: "What we do : Custom Development & IT Consulting Services",
};

export const contact = {
  canonical: "https://www.nextcosmostechnology.com/contact",
  title: "Get in touch",
  description:
    "Contact us to discover how our scalable software development and IT consulting services can transform your business operations and processes.",
  ogTitle: "Contact Us : ",
};

export const blog = {
  /*...*/
};
export const blogDetails = {
  /*...*/
};

export const privacy = {
  canonical: "https://www.nextcosmostechnology.com/privacy-policy",
  title: "Privacy Policy | Next Cosmos Technology",
  description:
    "Official Terms and Conditions for Next Cosmos Technbology Pvt Ltd. Covers privacy, liabilities, and user responsibilities.",
  ogTitle: "Privacy Policy : ",
};
export const terms = {
  canonical: "https://www.nextcosmostechnology.com/terms-conditions",
  title: "Terms and Conditions | Next Cosmos Technology",
  description:
    "Terms & Conditions for Next Cosmos Technbology Pvt Ltd. Effective  © 2022 - 2025. Covers usage rules, liabilities, and user obligations.",
  ogTitle: "Terms and Conditions : ",
};
export const fourZeroFour = {
  noindex: true,
  canonical: "https://www.nextcosmostechnology.com/page-not-found",
  title: "Page Not Found - 404 Error",
  description: "Page not found",
  keywords: "404, not found",
};
